var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.50174H1.5C0.947715 1.50174 0.5 1.94935 0.5 2.50152V8.50022C0.5 9.0524 0.947715 9.5 1.5 9.5H6.5C7.0523 9.5 7.5 9.0524 7.5 8.50022V2.50152C7.5 1.94935 7.0523 1.50174 6.5 1.50174H5.5M2.50098 1.49978C2.50098 0.947618 2.94869 0.5 3.50098 0.5H4.50098C5.05328 0.5 5.50098 0.947618 5.50098 1.49978V2.49957H2.50098V1.49978Z",
    stroke: "#4D5761",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.6450385eb3616b6bfb0843fa51b94104.svg";
export { ForwardRef as ReactComponent };